import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Facebook, Github, Mail } from 'lucide-react';
import { LazyImage } from './ui/lazy-image';

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary-dark text-white pt-16 pb-8 relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500 opacity-5 rounded-full blur-[100px]"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500 opacity-5 rounded-full blur-[100px]"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <LazyImage src="https://i.ibb.co/9mpxWhP/Simple-Modern-Minimalist-Circle-Design-Studio-Logo-2.png" alt="CMO Success Systems Logo" className="h-10 w-auto" />
            </Link>
            <p className="text-gray-text mb-4 max-w-md">
              AI-Powered Growth: Outthink Competitors, Outperform Markets. Centralize your marketing strategy, validate your ideas, and launch high-converting campaigns.
            </p>
            <div className="flex space-x-4 text-gray-text">
              <a href="#" className="hover:text-accent-bright transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-accent-bright transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="hover:text-accent-bright transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:text-accent-bright transition-colors">
                <Github size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Platform</h3>
            <ul className="space-y-2">
              <li><Link to="/product" className="text-gray-text hover:text-accent-bright transition-colors">Overview</Link></li>
              <li><Link to="/features" className="text-gray-text hover:text-accent-bright transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-gray-text hover:text-accent-bright transition-colors">Pricing</Link></li>
              <li><Link to="/compare" className="text-gray-text hover:text-accent-bright transition-colors">Comparisons</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-gray-text hover:text-accent-bright transition-colors">Blog</Link></li>
              <li><Link to="/videos" className="text-gray-text hover:text-accent-bright transition-colors">Videos</Link></li>
              <li><Link to="/resources" className="text-gray-text hover:text-accent-bright transition-colors">Guides</Link></li>
              <li><Link to="/resources" className="text-gray-text hover:text-accent-bright transition-colors">Case Studies</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-text hover:text-accent-bright transition-colors">About Us</Link></li>
              <li><Link to="/about" className="text-gray-text hover:text-accent-bright transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="text-gray-text hover:text-accent-bright transition-colors">Contact</Link></li>
              <li><a href="#" className="text-gray-text hover:text-accent-bright transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-text text-sm mb-4 md:mb-0">&copy; {new Date().getFullYear()} CMO Success Systems. All rights reserved.</p>
          <div className="flex items-center space-x-4">
            <a href="mailto:info@cmosuccesssystems.com" className="text-gray-text hover:text-accent-bright transition-colors flex items-center">
              <Mail size={18} className="mr-2" />
              info@cmosuccesssystems.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;